import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    search: () =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'web-assets/search',
                    method: 'POST',
                    types: [
                        types.SEARCH_WEB_ASSETS_REQUEST,
                        types.SEARCH_WEB_ASSETS_SUCCESS,
                        types.SEARCH_WEB_ASSETS_FAILURE
                    ]
                }
            });
        },
    uploadWebAsset: (file, fileNameToReplace) =>
        (dispatch) => {
            let body = new FormData();
            body.append('file', file);
            if (fileNameToReplace) {
                body.append('fileNameToReplace', fileNameToReplace);
            }

            return dispatch({
                [CALL_API]: {
                    endpoint: 'web-assets/create',
                    method: 'POST',
                    body: body,
                    types: [
                        types.UPLOAD_WEB_ASSETS_REQUEST,
                        types.UPLOAD_WEB_ASSETS_SUCCESS,
                        types.UPLOAD_WEB_ASSETS_FAILURE
                    ]
                }
            });
        },
    deleteWebAsset: (fileName) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'web-assets/delete',
                    method: 'POST',
                    body: { fileName : fileName },
                    types: [
                        types.DELETE_WEB_ASSETS_REQUEST,
                        types.DELETE_WEB_ASSETS_SUCCESS,
                        types.DELETE_WEB_ASSETS_FAILURE
                    ]
                }
            });
        },
}